/* Rizki Store - Badge "Best seller" sur les cartes produit + badge Epuise en capsule rouge */
(function () {
  var RIZKI_BEST_SELLERS = ['amlou-amandes', 'miel-de-caroubier-copie-copie', 'recette-royale-caroubier'];
  var BADGE_TEXT = '\u2b50\ufe0f Best seller';

  function handleFromPath(path) {
    var p = String(path).split('/products/');
    if (p.length < 2) return null;
    return p[1].split('/')[0].split('?')[0].split('#')[0];
  }

  function injectStyles() {
    if (document.getElementById('rizki-bestseller-card-styles')) return;
    var css = [
      '.rizki-badge-bestseller-card{position:absolute;top:1rem;left:1rem;z-index:2;background-color:#fcd6a1;color:#121212;font-size:1.1rem;font-weight:700;padding:.4rem .9rem;border-radius:999px;box-shadow:0 2px 6px rgba(0,0,0,.12);white-space:nowrap;pointer-events:none;line-height:1;}',
      '.card__badge .badge.color-scheme-5{background-color:#d02626 !important;color:#fff !important;border:none !important;border-radius:999px !important;padding:.4rem 1.1rem !important;font-weight:700 !important;letter-spacing:.03rem !important;text-transform:uppercase !important;}'
    ].join('');
    var s = document.createElement('style');
    s.id = 'rizki-bestseller-card-styles';
    s.textContent = css;
    document.head.appendChild(s);
  }

  function addCardBadges() {
    RIZKI_BEST_SELLERS.forEach(function (h) {
      var links = document.querySelectorAll("a[href*='/products/" + h + "']");
      Array.prototype.forEach.call(links, function (a) {
        if (handleFromPath(a.getAttribute('href') || '') !== h) return;
        var card = a.closest('.card-wrapper') || a.closest('.card');
        if (!card) return;
        var host = card.querySelector('.card__inner') || card.querySelector('.card__media') || card;
        if (!host || host.querySelector('.rizki-badge-bestseller-card')) return;
        if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
        var b = document.createElement('span');
        b.className = 'rizki-badge-bestseller-card';
        b.setAttribute('aria-hidden', 'true');
        b.textContent = BADGE_TEXT;
        host.appendChild(b);
      });
    });
  }

  function run() {
    injectStyles();
    addCardBadges();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run, { once: true });
  } else {
    run();
  }
})();
